export const Names = [
  "凛",
  "凜",
  "凪",
  "咲",
  "奏",
  "彩",
  "恵",
  "愛",
  "晴",
  "未",
  "杏",
  "来",
  "桜",
  "楓",
  "澪",
  "瞳",
  "紬",
  "結",
  "舞",
  "花",
  "茜",
  "華",
  "萌",
  "葵",
  "蘭",
  "詩",
  "遥",
  "鈴",
  "陽",
  "きみ",
  "きよ",
  "はな",
  "はる",
  "キミ",
  "キヨ",
  "トミ",
  "ハナ",
  "ハル",
  "フミ",
  "マサ",
  "ヨシ",
  "一花",
  "一華",
  "七海",
  "久子",
  "亜美",
  "京子",
  "佳奈",
  "信子",
  "優奈",
  "優子",
  "優花",
  "優衣",
  "充希",
  "光子",
  "光莉",
  "典子",
  "勝子",
  "千代",
  "千夏",
  "千尋",
  "千晴",
  "友美",
  "君子",
  "和奏",
  "和子",
  "和花",
  "咲希",
  "咲来",
  "咲良",
  "咲花",
  "咲茉",
  "唯愛",
  "啓子",
  "夏帆",
  "奈々",
  "孝子",
  "寧々",
  "幸子",
  "弘子",
  "彩乃",
  "彩夏",
  "彩愛",
  "彩羽",
  "彩花",
  "彩葉",
  "彩香",
  "心優",
  "心咲",
  "心愛",
  "心春",
  "心晴",
  "心結",
  "心花",
  "心陽",
  "心音",
  "恵子",
  "恵美",
  "悦子",
  "愛子",
  "愛梨",
  "愛美",
  "愛莉",
  "愛菜",
  "成美",
  "敏子",
  "文子",
  "日和",
  "日葵",
  "早紀",
  "明美",
  "明莉",
  "昭子",
  "智子",
  "智美",
  "望愛",
  "未来",
  "朱莉",
  "朱里",
  "杏奈",
  "柚希",
  "柚月",
  "柚羽",
  "栄子",
  "桃子",
  "桜子",
  "正子",
  "沙織",
  "洋子",
  "浩子",
  "清子",
  "照子",
  "玲奈",
  "理恵",
  "琴葉",
  "琴音",
  "由佳",
  "由美",
  "百花",
  "直子",
  "直美",
  "真央",
  "真由",
  "笑愛",
  "節子",
  "紀子",
  "純子",
  "紗奈",
  "紗良",
  "紗菜",
  "紬希",
  "結愛",
  "結月",
  "結菜",
  "結衣",
  "結音",
  "絵美",
  "美優",
  "美咲",
  "美月",
  "美桜",
  "美琴",
  "美穂",
  "美空",
  "美紀",
  "美結",
  "美羽",
  "美香",
  "良子",
  "花菜",
  "花音",
  "芳子",
  "芽依",
  "芽生",
  "芽衣",
  "茉白",
  "茉莉",
  "莉央",
  "莉子",
  "莉帆",
  "莉愛",
  "莉緒",
  "菜摘",
  "菜月",
  "裕子",
  "裕美",
  "詩乃",
  "詩織",
  "貞子",
  "里奈",
  "陽子",
  "陽菜",
  "陽葵",
  "静子",
  "音羽",
  "順子",
  "香織",
  "麻美",
  "麻衣",
  "あかり",
  "あゆみ",
  "こころ",
  "さくら",
  "すみれ",
  "つむぎ",
  "ひかり",
  "ひなた",
  "ひまり",
  "ひより",
  "めぐみ",
  "ゆかり",
  "久美子",
  "八重子",
  "千代子",
  "恵美子",
  "明日香",
  "由美子",
  "真由美",
  "美代子",
  "美智子",
  "菜々子",
  "陽菜乃",
  "麻衣子",
]
